import React, { Component } from 'react'

/**
 * Contains a render crash in a SINGLE past report so it can't white-screen the whole
 * /l/ prescription-making page. Patient history mixes report types (prescription, therapy,
 * screening, assessment) and data shapes from different sources (doctor-created, imported,
 * therapist-uploaded). A malformed record — e.g. a field that's an object where a string is
 * expected (React error #31) — would otherwise crash the entire page. With this boundary, the
 * bad report shows a small inline notice and every other report still renders.
 */
export default class PastReportErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('[PastReport] render error contained by boundary:', {
      label: this.props.label,
      message: error?.message,
      componentStack: errorInfo?.componentStack?.slice(0, 400),
    })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="hide-on-print-only"
          style={{
            margin: '8px 0',
            padding: '12px 16px',
            border: '1px dashed rgba(148, 163, 184, 0.6)',
            borderRadius: 8,
            background: 'rgba(148, 163, 184, 0.06)',
            color: '#64748b',
            fontSize: 13,
          }}
        >
          <div style={{ fontWeight: 600, marginBottom: 2 }}>This report couldn’t be displayed</div>
          <div>{this.props.label || 'A past report'} could not be rendered. The rest of the history is shown below.</div>
        </div>
      )
    }
    return this.props.children
  }
}
